import React, { useEffect, useState } from "react";
import { useUserDetail } from "../../../services/user-detail/user-detail.service";
import { UserUpdateFormType } from "../../../services/user-update/user-update.schema";
import { useUserUpdate } from "../../../services/user-update/user-update.service";
import { AvatarCustom, CentralLoadingIndicator } from "../../../components";
import GvProfileEditForm from "../../forms/GvProfileEditForm/GvProfileEditForm";
import { useNavigate } from "react-router-dom";
import GvUploadImageButton from "../../../components/GvUploadImageButton/GvUploadImageButton";
import { userActivityLogger } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";

const EditProfileContainer = () => {
  const { user, loading } = useUserDetail();
  const { userUpdate, loading: updateUserLoading, user: updatedUser, error } = useUserUpdate();
  const [fileImage, setFileImage] = useState<File>();
  const navigate = useNavigate();


  const handleChangeUploadImage = (file: File) => {
    setFileImage(file);
  };

  const handleSubmit = (data: UserUpdateFormType) => {
    userActivityLogger(MIXPANEL_EVENTS.USER_EDIT_PROFILE_CLICK, {});
    userUpdate(fileImage as File, data);
  };

  useEffect(() => {
    if (updatedUser) {
      userActivityLogger(MIXPANEL_EVENTS.EDIT_PROFILE_SUCCESS, {});
      navigate("/user-profile");
    }
    if (error) {
      userActivityLogger(MIXPANEL_EVENTS.EDIT_PROFILE_FAILURE, { failure_reason: error.graphQLErrors[0]?.message });
    }
  }, [updatedUser, error]);

  useEffect(() => {
    userActivityLogger(MIXPANEL_EVENTS.EDIT_PROFILE, {});
  }, []);

  if (loading || updateUserLoading ) {
    return <CentralLoadingIndicator />;
  }


  return (
    <div className="flex justify-center">
      <div className="w-full max-w-[528px] flex flex-col gap-4">
        <div className="flex justify-center">
          <GvUploadImageButton
            id="EditPetPhoto"
            icon={<AvatarCustom
              name={user?.firstName}
              width={100}
              height={100}
              avatarStyleToggle={true}
            />}
            url={user?.image}
            aspect={1}
            hideUploadButton={true}
            onChange={handleChangeUploadImage} />
        </div>
        {user ? <GvProfileEditForm
          initialValue={user}
          onSubmit={handleSubmit}
        />:
          null}
      </div>
    </div>
  );
};

export default EditProfileContainer;
